import React, { Component } from 'react';
import ReactTable from "react-table";
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { ToastsContainer, ToastsStore } from 'react-toasts';

import { FaFilter } from 'react-icons/fa';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { MdImportExport } from 'react-icons/md';

import "react-table/react-table.css";
import "../css/style.css";

import MenuComponent2 from './MenuComponent2';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

import { SELECTED_ORDER_IDX } from '../constants';
import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR } from '../icon';

import queryString from 'query-string'
import KhaiHqByPackage from './KhaiHqByPackage';
import StatisticService from '../services/StatisticService';

class KhaiHq extends Component {
  constructor() {
    super();
    const numOfMonths = 24;
    var fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000 * 3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    var toDate = new Date(new Date().getTime() + 60 * 60 * 60 * 1000 * 3);
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      show: false,
      allStatus: [],
      selectedPage: 1,
      fromDate: fromDate,
      toDate: toDate,
      shipCode: '',
      packages: [],
      workOrders: [],
      findCode: '',
      count: 0,
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          Header: 'ID',
          accessor: 'id',
          filterable: false
        },
        {
          Header: couterpart.translate('ship_code'),
          accessor: 'shipCode',
          filterable: false,
          Cell: row => (
            this.linkToDetails(row)
          )
        },
        {
          Header: couterpart.translate('ship_note'),
          accessor: 'shipNote',
          filterable: false
        },
        {
          Header: couterpart.translate('ship_at'),
          accessor: 'shipAtTs',
          filterable: false
        }],
      selectedPackage: '',
      selectedDate: '',
      columnHqs: [
        {
          Header: couterpart.translate('khaihq_shipAt'),
          accessor: 'shipAt',
          width: 150
        },
        {
          Header: couterpart.translate('khaihq_pakage'),
          accessor: 'shipCode',
          width: 150
        }, {
          Header: couterpart.translate('khaihq_chungloaihh'),
          accessor: 'chungLoaiHh',
          filterable: false
        }, {
          Header: couterpart.translate('khaihq_chotdshq'),
          accessor: 'count'
        }, {
          Header: couterpart.translate('khaihq_thuctedshq'),
          accessor: 'countTt',
          filterable: false
        }, {
          Header: couterpart.translate('khaihq_chenhlech'),
          accessor: 'chenhLech',
          width: 150
        }
      ]
    };
  }

  renderEditButton(row) {
    if (AuthenticationService.isShipping() || AuthenticationService.isService()) {
      return (<div>
        <button className="myButton" onClick={() => this.exportPackagesToExcel(row)}>
          <MdImportExport color={ICON_COLOR} />
          &nbsp;{couterpart.translate('button_export')}</button>
      </div>
      );
    } else {
      return (<></>);
    }
  }

  linkToDetails(row) {
    return (
      <label className="label_link" href="#!" onClick={() => { this.handleEdit(row) }}>{row.original.shipCode}</label>
    )
  }

  handleEdit(row) {
    // if (AuthenticationService.isShipping() || AuthenticationService.isService()) {
    //   let s = WorkOrderUtil.convertToDate2(row.original.shipAtTs)
    //   this.setState({
    //     show: true,
    //     selectedPackage: row.original.shipCode,
    //     selectedPackageNote: row.original.shipNote,
    //     // selectedShipAt: s,
    //     packageDate: s,
    //     packageNo: row.original.shipCode,
    //     packageNote: row.original.shipNote
    //   });
    // }
  }

  onFilteredChangeCustom = (value, accessor) => {
    let filtered = this.state.packages;
    let insertNewFilter = 1;

    if (filtered.length > 0) {
      filtered.forEach((filter, i) => {
        if ("country" === accessor) {
          if (value === "" || !value.length) filtered.splice(i, 1);
          else filter["value"] = value;
          insertNewFilter = 0;
        }
      });
    }

    if (insertNewFilter) {
      filtered.push({ id: accessor, value: value });
    }

    this.setState({ filtered: filtered });
  };

  componentDidMount() {

    const query = queryString.parse(this.props.location.search);
    // console.log('query', query);
    if (query.caller === '0') { //Clicked on NAV
      WorkOrderUtil.removeItem("shipPackages.fromDate")
      WorkOrderUtil.removeItem("shipPackages.toDate")
    }

    let fromDate = WorkOrderUtil.getItem("shipPackages.fromDate");
    let toDate = WorkOrderUtil.getItem("shipPackages.toDate");
    let findCode = WorkOrderUtil.getItem("shipPackages.findCode");

    const numOfMonths = 12;
    if (fromDate === null || fromDate === undefined) {
      fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000);//numOfMonths month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    let tmp = WorkOrderUtil.getItem('shipPackages.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }
    let selectedRow = WorkOrderUtil.getItem('shipPackages.selectedRow') ? parseInt(WorkOrderUtil.getItem('shipPackages.selectedRow')) : 0
    this.setState({
      fromDate: fromDate,
      toDate: toDate,
      selectedPage: iSelectPage,
      selectedRow: selectedRow,
      findCode: findCode
    }, () => {
      this.filterOrdersBy();
    });

  }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected,
      selectAll: 2
    }, () => {
      sessionStorage.setItem(`${SELECTED_ORDER_IDX}`, this.state.selected);
    });
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterOrdersBy();
  }

  toggleSelectAll() {
    let newSelected = {};

    if (this.state.selectAll === 0) {
      this.state.shipPackages.forEach(x => {
        newSelected[x.id] = true;
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    });
  }

  clearSearchInfo() {
    WorkOrderUtil.removeItem("shipPackages.fromDate")
    WorkOrderUtil.removeItem("shipPackages.toDate")
    WorkOrderUtil.removeItem("shipPackages.findCode")
    WorkOrderUtil.removeItem("shipPackages.selectedShipCode")
    WorkOrderUtil.removeItem("shipPackages.selectedRow")
  }

  saveSearchInfo(fromDate, toDate, selectedShipCode, selectedRow, findCode) {
    if (fromDate) {
      WorkOrderUtil.saveItem("shipPackages.fromDate", fromDate);
    }

    if (toDate) {
      WorkOrderUtil.saveItem("shipPackages.toDate", toDate);
    }
    WorkOrderUtil.saveItem("shipPackages.selectedShipCode", selectedShipCode);
    WorkOrderUtil.saveItem("shipPackages.selectedRow", selectedRow);
    WorkOrderUtil.saveItem("shipPackages.findCode", findCode);
  }

  filterOrdersBy() {
    var fromDate = this.state.fromDate;
    var toDate = this.state.toDate;
    var findCode = this.state.findCode;
    this.setState({ packages: [], shipCode: '', selectedRow: 0, selectedPage: 0 });

    WorkOrderDataService.retrieveShipPackagesBy(fromDate, toDate, findCode)
      .then(data => {
        if (data.message === undefined) {
          let selectedRow = 0;
          let selectedShipCode = '';

          if (data instanceof Array) {
            if (data.length > 0) {
              selectedShipCode = data[selectedRow].shipCode;
            } else {
              selectedShipCode = '0';
            }

            this.setState({ packages: data, shipCode: selectedShipCode, selectedRow: selectedRow });

          }
          this.saveSearchInfo(fromDate, toDate, selectedShipCode, selectedRow, findCode);

        } else {
          this.setState({ packages: [], shipCode: '' });
          ToastsStore.error(data.message);
        }
      });
  }

  handleFromDateChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({
      fromDate: sDate
    }));
  }

  handleShipCodeChange(e) {
    let vl = e.target.value
    this.setState(prevState => ({
      findCode: vl
    }));
  }

  handleToDateChange(date) {
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({
      toDate: sDate
    }));
  }

  renderStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }
    return (
      <select onChange={this.handleStatusChange.bind(this)}
        value={this.state.status}>
        <option value="all">{couterpart.translate('workorder_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 1;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderWoStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <select onChange={this.handleWoStatusChange.bind(this)}
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderChangeStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }
    if (AuthenticationService.isAdmin()) {
      return (
        <select onChange={this.handleSetStatusChange.bind(this)}>
          {this.state.allStatus.filter(y => {
            return y.type === 1 && y.status !== 1;
          }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
        </select>
      );
    } else {
      return (
        <select onChange={this.handleSetStatusChange.bind(this)}>
          {this.state.allStatus.filter(y => {
            return y.type === 1;
          }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
        </select>
      );
    }
  }

  handleClose() {
    this.setState({ show: false });
  }

  handlePackageDateChange(date) {
    //var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      packageDate: date,
      // selectedShipAt: date                   
    });
  }

  handlePackageNoChange(e) {
    var value = e.target.value;
    this.setState({
      packageNo: value
    });
  }

  handlePackageNoteChange(e) {
    var value = e.target.value;
    this.setState({
      packageNote: value
    });
  }

  savePackageInfo() {
    if (this.state.packageDate === undefined || this.state.packageDate === null) {
      alert(couterpart.translate('error_ship_date_invalid'));
      return;
    }

    if (this.state.packageNo === undefined || this.state.packageNo === null || this.state.packageNo.trim().length < 1) {
      alert(couterpart.translate('error_ship_code_invalid'));
      return;
    }


    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(this.state.packageDate);

    WorkOrderDataService.updateShipping(this.state.selectedPackage, {
      shipCode: this.state.packageNo.trim(),
      shipNote: this.state.packageNote ? this.state.packageNote.trim() : '',
      shipDate: sDate
    }).then(data => {
      console.log('updateShipping', data);
      this.setState({
        show: false
      });
      this.filterOrdersBy();
    });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  exportPackagesToExcel(row) {
    try {
      this.setState({ spinnerVisible: true }, () => {
        WorkOrderDataService.exportPackages({
          shipCode: row.original.shipCode
        }).then(data => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', row.original.shipCode + '-' + this.state.fromDate + "-" + this.state.toDate + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  renderKhaiHqs() {
    return (
      <ReactTable
        NoDataComponent={() => null}
        previousText={"<"}
        nextText={">"}
        data={this.state.shipPackageStatistics}
        columns={this.state.columnHqs}
        defaultPageSize={10}
        showPageSizeOptions={true}
        pageSizeOptions={[3, 5, 10, 20, 50, 100]}
        getTrProps={(state, rowInfo, column) => {
          if (rowInfo && rowInfo.row) {
            return {
              onClick: (e) => {
                // this.setState({
                //   selected: rowInfo.index,
                //   workOrderId: rowInfo.original.id
                // }, () => {
                //   WorkOrderUtil.saveItem('shipPackages.workorders.selectedIndex', this.state.selected)
                // })
              },
              style: {
                background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                color: rowInfo.index === this.state.selected ? 'black' : 'black'
              }
            }
          } else {
            return {}
          }
        }
        }
      />);
  }

  render() {
    if (!AuthenticationService.isShipping() && !AuthenticationService.isAdmin()) {
      return (<div>Unauthorized access.</div>);
    }

    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <div className="row">
          <div className="col-1">
            <label style={{ width: "100%", marginTop: "5px" }}><b>{couterpart.translate('order_date_from')}</b></label>
          </div>
          <div className="col-2">
            <div className="customDatePickerWidth" style={{ marginTop: "5px" }}>
              <DatePicker name="orderDateFrom"
                dateFormat="MM/dd/yyyy hh:mm"
                selected={WorkOrderUtil.convertToDate(this.state.fromDate)}
                onChange={this.handleFromDateChange.bind(this)} />
            </div>
          </div>
          <div className="col-1">
            <label style={{ width: "100%", marginTop: "5px" }}><b>{couterpart.translate('order_date_to')}</b></label>
          </div>
          <div className="col-2">
            <div className="customDatePickerWidth" style={{ marginTop: "5px" }}>
              <DatePicker name="orderDateTo"
                dateFormat="MM/dd/yyyy hh:mm"
                selected={WorkOrderUtil.convertToDate(this.state.toDate)}
                onChange={this.handleToDateChange.bind(this)} />
            </div>
          </div>
          <div className="col-2">
            <input type="text" name="shipCode" size="5" style={{ width: "100%", marginTop: "5px" }} defaultValue={this.state.findCode}
              onChange={this.handleShipCodeChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleShipCodeChange(e) }, 0); }} />
          </div>
          <div className="col-2">
            <button className="myButton"
              onClick={this.onFilter.bind(this)}>
              <FaFilter color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_filter')}</button>
          </div>
        </div>
        <ReactTable
          className="-striped -highlight"
          previousText={"<"}
          nextText={">"}
          pageText={"Trang"}
          data={this.state.packages}
          columns={this.state.columns}
          defaultPageSize={10}
          showPageSizeOptions={true}
          pageSizeOptions={[3, 5, 10, 20]}
          headerStyle={{
            'background-color': 'green'
          }}
          page={this.state.selectedPage}
          onPageChange={(pageIndex) => {
            if (this.state.selectedPage === pageIndex) {
              this.setState({ selectedPage: pageIndex }, () => {
                WorkOrderUtil.saveItem('shipPackages.selectedShipCode', this.state.shipCode);
                WorkOrderUtil.saveItem('shipPackages.selectedPage', pageIndex);
                WorkOrderUtil.saveItem('shipPackages.selectedRow', this.state.selectedRow);
              })
            } else {
              this.setState({ selectedPage: pageIndex, selectedRow: -1, shipCode: '' }, () => {
                WorkOrderUtil.saveItem('shipPackages.selectedShipCode', this.state.shipCode);
                WorkOrderUtil.saveItem('shipPackages.selectedPage', pageIndex);
                WorkOrderUtil.saveItem('shipPackages.selectedRow', this.state.selectedRow);
              })
            }
            this.setState({ selectedPage: pageIndex })
          }}
          getTrProps={(state, rowInfo, column) => {
            if (rowInfo && rowInfo.row) {
              // console.log('this.state.selectedRow - rowInfo.index',this.state.selectedRow, rowInfo.index)
              return {
                onClick: (e) => {
                  this.setState({
                    selectedRow: rowInfo.index,
                    shipCode: rowInfo.original.shipCode
                  }, () => {
                    WorkOrderUtil.saveItem('shipPackages.selectedShipCode', this.state.shipCode);
                    WorkOrderUtil.saveItem('shipPackages.selectedRow', this.state.selectedRow);
                    let code = this.state.shipCode;
                    StatisticService.getKiemTraHq(code).then(data => {
                      if (data !== undefined && data !== null) {
                        this.setState({ shipPackageStatistics: data })
                      }
                    });
                  })
                },
                style: {
                  background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                  color: rowInfo.index === this.state.selectedRow ? 'white' : 'black',
                  padding: 1
                }
              }
            } else {
              return {}
            }
          }
          }
        />
        <div className="row">
          <div className="col-12">&nbsp;</div>
        </div>
        { this.renderKhaiHqs() }
        <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Package</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_date')} : </span>
              </div>
              <div className="col-2">
                <DatePicker name="packageDate" className="field_margin"
                  selected={this.state.packageDate}
                  dateFormat="MM/dd/yyyy hh:mm"
                  onChange={this.handlePackageDateChange.bind(this)} />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('wo_package_no')} : </span>
              </div>
              <div className="col-8">
                <input type="text" name="packageNo" className="inputBox3 field_margin" defaultValue={this.state.selectedPackage}
                  onChange={this.handlePackageNoChange.bind(this)}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <span className="field_margin">{couterpart.translate('ship_note')} : </span>
              </div>
              <div className="col-8">
                <input type="text" name="packageNote" className="inputBox3 field_margin" defaultValue={this.state.selectedPackageNote}
                  onChange={this.handlePackageNoteChange.bind(this)}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
            <Button variant="primary" onClick={this.savePackageInfo.bind(this)}>OK</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default withRouter(KhaiHq);